"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var getRandomString_1 = __importDefault(require("../../../utils/getRandomString"));
var setVisiblitySensitiveTimeout_1 = __importDefault(require("../../../utils/timer/setVisiblitySensitiveTimeout"));
var Snack_1 = __importDefault(require("../Snack"));
var types_1 = require("../types");
var styles_1 = require("./styles");
var snackbar;
var snackHasAction = function (snack) { return !!(snack.buttonTitle && snack.onButtonClick); };
var stopToasterAnimation = function (snack) {
    var _a;
    (_a = snack === null || snack === void 0 ? void 0 : snack.timer) === null || _a === void 0 ? void 0 : _a.pause();
};
var startToasterAnimation = function (snack) {
    var _a;
    (_a = snack === null || snack === void 0 ? void 0 : snack.timer) === null || _a === void 0 ? void 0 : _a.resume();
};
var Snackbar = /** @class */ (function (_super) {
    __extends(Snackbar, _super);
    function Snackbar(props) {
        var _this = _super.call(this, props) || this;
        _this.removalAnimationDuration = 300;
        _this.handlePathChange = function () {
            _this.state.shownSnacks.forEach(function (snack) {
                if (snack.removeSnackOnPathChange) {
                    _this.removeSnack(snack.id);
                }
            });
        };
        _this.queuedSnacks = [];
        _this.state = {
            shownSnacks: [],
            snackIdsRemovalAnimated: [],
        };
        snackbar = _this;
        document.body.addEventListener('path-change', _this.handlePathChange);
        document.addEventListener('snackBar_showSnackFromModule', _this.showSnackFromModule);
        return _this;
    }
    Snackbar.prototype.componentWillUnmount = function () {
        document.body.removeEventListener('path-change', this.handlePathChange);
    };
    Snackbar.showSnack = function (config) {
        snackbar.showSnack(config);
    };
    Snackbar.showSnackModule = function (config) {
        document.dispatchEvent(new CustomEvent('snackBar_showSnackFromModule', { detail: config }));
    };
    // eslint-disable-next-line class-methods-use-this
    Snackbar.prototype.showSnackFromModule = function (_a) {
        var detail = _a.detail;
        snackbar.showSnack(detail);
    };
    Snackbar.prototype.showSnack = function (config) {
        if (this.state.shownSnacks.length < this.props.maxShownSnacks) {
            this.addToShownSnacks(config);
        }
        else {
            this.queuedSnacks.push(config);
        }
    };
    Snackbar.prototype.removeSnack = function (id) {
        var snack = this.state.shownSnacks.find(function (s) { return s.id === id; });
        if (snack) {
            if (snack.timer) {
                snack.timer.cancel();
            }
            this.removeFromShownSnacks(id);
        }
    };
    Snackbar.prototype.addToShownSnacks = function (config) {
        var _this = this;
        var snack = __assign(__assign({}, config), { id: (0, getRandomString_1.default)() });
        var hasAction = snackHasAction(snack);
        // if snack has action button, the snack will be dismissed when the button is clicked
        if (hasAction) {
            var onButtonClick_1 = snack.onButtonClick;
            snack.onButtonClick = function () {
                _this.removeFromShownSnacks(snack.id);
                if (onButtonClick_1) {
                    onButtonClick_1();
                }
            };
        }
        // if the snack has custom duration, it will be dismissed after that duration
        // if the snack doesn't have custom duration and no action, it will be dismissed after default duration.
        if (snack.duration || !hasAction) {
            snack.timer = (0, setVisiblitySensitiveTimeout_1.default)(function () {
                _this.removeFromShownSnacks(snack.id);
            }, snack.duration || this.props.defaultDuration);
        }
        this.setState(function (prevState) { return ({
            shownSnacks: __spreadArray(__spreadArray([], prevState.shownSnacks, true), [snack], false),
        }); });
    };
    Snackbar.prototype.removeFromShownSnacks = function (id) {
        var _this = this;
        var snack = this.state.shownSnacks.find(function (s) { return s.id === id; });
        if (snack) {
            this.setState(function (prevState) { return ({
                snackIdsRemovalAnimated: __spreadArray(__spreadArray([], prevState.snackIdsRemovalAnimated, true), [id], false),
            }); });
            (0, setVisiblitySensitiveTimeout_1.default)(function () {
                _this.setState(function (prevState) { return ({
                    shownSnacks: prevState.shownSnacks.filter(function (s) { return s.id !== id; }),
                    snackIdsRemovalAnimated: prevState.snackIdsRemovalAnimated.filter(function (s) { return s !== id; }),
                }); });
                if (_this.queuedSnacks.length > 0) {
                    var config = _this.queuedSnacks.shift();
                    if (config) {
                        _this.addToShownSnacks(config);
                    }
                }
            }, this.removalAnimationDuration);
        }
    };
    Snackbar.prototype.render = function () {
        var _this = this;
        var _a = this.props, position = _a.position, animationType = _a.animationType;
        var _b = this.state, shownSnacks = _b.shownSnacks, snackIdsRemovalAnimated = _b.snackIdsRemovalAnimated;
        return ((0, jsx_runtime_1.jsx)(styles_1.SnackbarContainer, __assign({ position: position, animationType: animationType }, { children: shownSnacks.map(function (snack) {
                var doesnNotHaveAction = !snackHasAction(snack);
                var onDismiss = snack.isNotDismissible && doesnNotHaveAction ? undefined : function () { return _this.removeSnack(snack.id); };
                return ((0, jsx_runtime_1.jsx)(Snack_1.default, __assign({}, snack, { isRemovalAnimated: snackIdsRemovalAnimated.includes(snack.id), animationType: _this.props.animationType, position: _this.props.position, onDismiss: onDismiss, onMouseOver: function () { return stopToasterAnimation(snack); }, onMouseOut: function () { return startToasterAnimation(snack); } }), snack.id));
            }) })));
    };
    Snackbar.defaultProps = {
        maxShownSnacks: 3,
        defaultDuration: 5000,
        animationType: types_1.EAnimationType.slide,
        position: 'topRight',
    };
    return Snackbar;
}(react_1.default.Component));
exports.default = Snackbar;
